<div id="print-section" class="style-print-section">
  <div class="general-container">
    <p>
      {{ 'evidenceReleaseFolioDocumentTag.creationDate' | translate }} :
      <strong>{{ evidenceFolio.timestamp | date: 'dd/MM/yyyy' }}</strong>
    </p>
    <div class="div-header-container">
      <div class="div-logo-container">
        <img
          alt="Logo"
          src='{{ logoUrl }}'
          id="logo"
          (error)="setDefaultImage($event);">
      </div>

      <div name="title-container" id="title-container" class="div-title-container">
        <div class="div-right-title">
          <p>{{ 'evidenceReleaseFolioDocumentTag.title' | translate }}</p>
        </div>

        <div class="div-left-title">
          <span>{{ evidenceFolio.folio }}</span>
        </div>
      </div>

      <div id="div-barcode">
        <ngx-barcode
          id="barcode"
          [bc-value]="evidenceFolio.folio"
          [bc-display-value]="false"
          [bc-width]="1"
          [bc-font-size]="10"
          [bc-height]="45"
          [bc-margin]="0"
          [bc-margin-top]="0"
          [bc-margin-bottom]="0"
          [bc-margin-left]="5"
          [bc-margin-right]="0">
        </ngx-barcode>
      </div>
    </div>

    <div class="div-summary-info">
      <div id="shipper-data">
        <div class="partial-text-divider">
          <div class="subtitle">
            <span>{{ 'evidenceReleaseFolioDocumentTag.subtitleShipper' | translate }}</span>
          </div>
          <div class="divider">
            <hr>
          </div>
        </div>

        <table aria-describedby="table-shipper-data" class="table-shipper-data" *ngIf="shipperData">
          <tr>
            <th id="rfc-header"> {{ 'evidenceReleaseFolioDocumentTag.RFC' | translate }}</th>
            <th id="fiscalAddress-header"> {{ 'evidenceReleaseFolioDocumentTag.fiscalAddress' | translate }}</th>
          </tr>
          <tr>
            <td> {{ shipperData.rfc }} </td>
            <td> {{ shipperData.direccionFiscal.calle }} </td>
          </tr>
        </table>
      </div>

      <div id="merchandise-data">
        <div class="partial-text-divider">
          <div class="subtitle">
            <span>{{ 'evidenceReleaseFolioDocumentTag.subtitleMerchandise' | translate }}</span>
          </div>
          <div class="divider">
            <hr>
          </div>
        </div>

        <table aria-describedby="table-resume-indicator" class="table-resume-indicators">
          <th id="th-resume-indicators"></th>
          <tr>
            <td><img alt="Pieces" src='../../../assets/pieces.svg'/></td>
            <td class="number-indicator">{{ evidenceFolio.totalPieces }}</td>
            <td class="text-indicator">{{ 'evidenceReleaseFolioDocumentTag.totalPieces' | translate }}</td>
            <td><img alt="Boxes" src='../../../assets/boxes.svg'/></td>
            <td class="number-indicator">{{ evidenceFolio.totalBoxes }}</td>
            <td class="text-indicator">{{ 'evidenceReleaseFolioDocumentTag.totalBoxes' | translate}}</td>
            <td><img alt="Pallets" src='../../../assets/pallets.svg'/></td>
            <td class="number-indicator">{{ evidenceFolio.totalPallets }}</td>
            <td class="text-indicator">{{ 'evidenceReleaseFolioDocumentTag.totalPallets' | translate }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngFor="let row of evidenceFolio.rows; let i=index">
      <div id="evidence-info">
        <table mat-table aria-describedby="table-evidence-info" [dataSource]="dataSource?.data[i].orders">

          <ng-container matColumnDef="shipmentId">
            <th
              id="shipmentId"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.shipmentId' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.shipmentId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tripType">
            <th
              id="tripType"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.tripType' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.tripType }}
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceType">
            <th
              id="serviceType"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.serviceType' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.serviceType }}
            </td>
          </ng-container>

          <ng-container matColumnDef="orderId">
            <th
              id="orderId"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.orderId' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.orderId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="internalReference">
            <th
              id="internalReference"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.internalReference' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.internalReference }}
            </td>
          </ng-container>

          <ng-container matColumnDef="invoice">
            <th
              id="invoice"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.invoice' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.invoice }}
            </td>
          </ng-container>

          <ng-container matColumnDef="orderGrouper">
            <th
              id="orderGrouper"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.orderGrouper' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.orderGrouper }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsEvidence; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsEvidence;"></tr>
        </table>
      </div>

      <div id="additional-info">
        <table mat-table aria-describedby="table-additional-info" [dataSource]="dataSource?.data[i].details">
          <ng-container matColumnDef="account">
            <th
              id="account"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.account' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.account }}
            </td>
          </ng-container>

          <ng-container matColumnDef="origin">
            <th
              id="origin"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.origin' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.origin.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="destinationName">
            <th
              id="destinationName"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.destinationName' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.destination.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="destinationAddress">
            <th
              id="destinationAddress"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.destinationAddress' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.destination.address }}
            </td>
          </ng-container>

          <ng-container matColumnDef="destinationMunicipality">
            <th
              id="destinationMunicipality"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.destinationMunicipality' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.destination.municipality }}
            </td>
          </ng-container>

          <ng-container matColumnDef="destinationState">
            <th
              id="destinationState"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.destinationState' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.destination.state }}
            </td>
          </ng-container>

          <ng-container matColumnDef="carrier">
            <th
              id="carrier"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.carrier' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.carrier.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="realDeliveryDate">
            <th
              id="realDeliveryDate"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'evidenceReleaseFolioDocumentTag.realDeliveryDate' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.deliveryDate | date: 'dd/MM/yyyy' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsAdditional; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsAdditional;"></tr>
        </table>
      </div>

      <div id="resume-by-row">
        <table aria-describedby="table-resume-indicator" class="table-resume-indicators">
          <th id="th-resume-indicators"></th>
          <tr>
            <td><img alt="Pieces" src='../../../assets/pieces.svg'/></td>
            <td class="number-indicator">{{ row.totalPiecesByRow }}</td>
            <td class="text-indicator">{{ 'evidenceReleaseFolioDocumentTag.pieces' | translate }}</td>
            <td><img alt="Boxes" src='../../../assets/boxes.svg'/></td>
            <td class="number-indicator">{{ row.totalBoxesByRow }}</td>
            <td class="text-indicator">{{ 'evidenceReleaseFolioDocumentTag.boxes' | translate }}</td>
            <td><img alt="Pallets" src='../../../assets/pallets.svg'/></td>
            <td class="number-indicator">{{ row.totalPalletsByRow }}</td>
            <td class="text-indicator">{{ 'evidenceReleaseFolioDocumentTag.pallets' | translate }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>